import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { showServerErrors } from 'utility/showServerErrors';

const axiosIntercept = (axios: AxiosInstance) => {
  // Request interceptor
  axios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      // Modify the request config here, such as adding headers or authentication tokens
      const user = JSON.parse(localStorage.getItem('user') as any);

      if (user && user.accessToken) {
        const token = user?.accessToken;
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
      return config;
    },
    error => {
      // Handle request errors here
      return Promise.reject(error);
    },
  );

  // Response interceptor
  axios.interceptors.response.use(
    response => {
      const newToken = response.headers['x-new-token'];
      if (newToken) {
        // Update stored token
        let user = JSON.parse(localStorage.getItem('user') as any) || {};
        user.accessToken = newToken;
        localStorage.setItem('user', JSON.stringify(user));
        axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      }
      return response;
    },
    error => {
      if (error.response) {
        if (error.response.status === 403) {
          const isDeactivated = error.response.headers['x-deactivated'];
          if (isDeactivated) {
            Object.keys(localStorage).forEach(key => {
              if (key.toLowerCase().includes('user')) {
                localStorage.removeItem(key);
              }
            });
            window.location.href = '/login';
            return Promise.reject(error);
          }
        }

        // Check for specific exception
        if (error.response.data?.includes('ForbiddenProjectAccessException')) {
          window.location.href = '/';
          return Promise.reject(error);
        }
      }

      // Handle all other errors
      showServerErrors(error);
      return Promise.reject(error);
    },
  );
};

export default axiosIntercept;
